import React from 'react';

import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { Avatar, Box, Button } from '@mui/material';
import { useTheme } from '@mui/material/styles';

import * as amplitude from '@amplitude/analytics-browser';

import { useJWT } from '../../contexts/JWTProvider';
import { ServiceThemeOptions } from '../../themes';
import { Analytics, createAnalyticsContext } from '../../utils/analytics';
import { onboardStyles } from '../ComponentStyles';

interface OnboardHeaderProps {
  onBackClick: () => void;
  imageName: string;
  tsp: string;
  serviceName: string;
  backgroundColor: string;
}

/**
 * Header component for the onboarding page with back button and TSP logo
 */
const OnboardHeader: React.FC<OnboardHeaderProps> = ({
  onBackClick,
  imageName,
  tsp,
  serviceName,
  backgroundColor,
}) => {
  const theme = useTheme() as ServiceThemeOptions;
  const jwt = useJWT();

  // Handle back button click with tracking
  const handleBackClick = () => {
    // Track in Amplitude
    amplitude.track('Onboarding Back Button Clicked', {
      tsp,
      serviceName,
    });

    // Track back navigation in analytics/Slack
    const analyticsContext = createAnalyticsContext(jwt, serviceName);
    Analytics.backToTspSelection(analyticsContext, tsp);

    onBackClick();
  };

  return (
    <Box
      sx={{
        ...onboardStyles.headerContainer,
        bgcolor: backgroundColor,
      }}
    >
      <Button
        sx={onboardStyles.backButton(theme as any)}
        onClick={handleBackClick}
      >
        <ArrowBackIcon sx={onboardStyles.backIcon(theme as any)} />
      </Button>

      <Box sx={onboardStyles.logoContainer}>
        <Avatar
          src={`/images/${imageName}.png`}
          variant='square'
          sx={{
            ...onboardStyles.avatar,
            backgroundColor: 'transparent',
          }}
        />
      </Box>
    </Box>
  );
};

export default OnboardHeader;
